import { render, staticRenderFns } from "./InvestmentForm.vue?vue&type=template&id=378c16b3&"
import script from "./InvestmentForm.vue?vue&type=script&lang=ts&"
export * from "./InvestmentForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports